import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent {
  //  properties
  @Input() title: string;
  @Input() description: string;
  @Input() subtitle: string;
  @Input() icon: string;
}
